import React, { useEffect, useState } from "react";
import axios from "axios";
import config from "../../../config";
import { showToast } from "../../../utils/toast";
import ItemModal from "../Modals/ItemModal";

export default function InventoryItems() {
  const [items, setItems] = useState([]);
  const [categories, setCategories] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);

  useEffect(() => {
    fetchItems();
    fetchCategories();
  }, []);

  const fetchItems = async () => {
    const res = await axios.get(
      `${config.apiBaseUrl}/inventory/get-items.php`
    );
    if (res.data.success) setItems(res.data.data);
  };

  const fetchCategories = async () => {
    const res = await axios.get(
      `${config.apiBaseUrl}/inventory/get-categories.php`
    );
    if (res.data.success) setCategories(res.data.data);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this item?")) return;

    const res = await axios.delete(
      `${config.apiBaseUrl}/inventory/delete-item.php`,
      { data: { item_id: id } }
    );

    if (res.data.success) {
      showToast("success", res.data.message);
      fetchItems();
    }
  };

  return (
    <div className="container-fluid">

      <div className="d-flex justify-content-between mb-3">
        <h5>Items Master</h5>
        <button
          className="btn btn-primary btn-sm"
          onClick={() => {
            setEditData(null);
            setShowModal(true);
          }}
        >
          + Add Item
        </button>
      </div>

      <div className="card">
        <div className="card-body">

          <table className="table table-bordered table-hover">
            <thead className="table-light">
              <tr>
                <th>#</th>
                <th>Item</th>
                <th>Category</th>
                <th>Qty</th>
                <th>Min Qty</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, index) => (
                <tr
                  key={item.item_id}
                  className={
                    item.quantity <= item.minimum_quantity
                      ? "table-danger"
                      : ""
                  }
                >
                  <td>{index + 1}</td>
                  <td>{item.item_name}</td>
                  <td>{item.category_name}</td>
                  <td>{item.quantity}</td>
                  <td>{item.minimum_quantity}</td>
                  <td>{item.status}</td>
                  <td>
                    <button
                      className="btn btn-sm btn-warning me-2"
                      onClick={() => {
                        setEditData(item);
                        setShowModal(true);
                      }}
                    >
                      Edit
                    </button>
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => handleDelete(item.item_id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

        </div>
      </div>

      {showModal && (
        <ItemModal
          show={showModal}
          onClose={() => setShowModal(false)}
          categories={categories}
          refresh={fetchItems}
          editData={editData}
        />
      )}

    </div>
  );
}